import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { experimentClient } from '$lib/services/experiments/client_v2';
import { REG_PATH_KEYS } from '$lib/utils/constants';
import { getRegPathKey } from '$lib/utils/dynamic-config';

const isAltPaymentRegPath = () => {
	const regPathKey = getRegPathKey(REG_PATH_KEYS.DEFAULT_SUBSCRIBER);
	return (
		regPathKey === REG_PATH_KEYS.IOS_ALT_PAYMENT_SUBSCRIBER_2_0 ||
		regPathKey === REG_PATH_KEYS.IOS_ALT_PAYMENT_SUBSCRIBER_1_0 ||
		regPathKey === REG_PATH_KEYS.ANDROID_ALT_PAYMENT_SUBSCRIBER_2_0 ||
		regPathKey === REG_PATH_KEYS.ANDROID_ALT_PAYMENT_SUBSCRIBER_1_0
	);
};

/**
 * @type {{[key: string]: import('$lib/utils/page').PageCondition}}
 */
const pageConditions = {
	oauthChoiceExperiment: {
		condition: async () => {
			await experimentClient.initializeExperiment(
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.experimentKey
			);
			return experimentClient.isVariantActive(
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.experimentKey,
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.variants.test
			);
		},
		resolve: async () => await import('../_browser-oauth-choice/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => {
			if (isAltPaymentRegPath()) {
				await experimentClient.initializeExperiment(
					ACTIVE_EXPERIMENTS.ABCM2_MOVE_PHONE_NUMBER_TO_SUB_PAGE.experimentKey
				);
			}
			return await import('../_browser/Page.svelte');
		},
	},
};

export { pageConditions };
